var map = {
	"./ad-free.svg": [
		35555,
		5555
	],
	"./ai.svg": [
		93147,
		3147
	],
	"./awards.svg": [
		28307,
		8307
	],
	"./backArrow.svg": [
		49801,
		9801
	],
	"./bug.svg": [
		10687,
		687
	],
	"./bulb.svg": [
		26596,
		6596
	],
	"./bulletPoints.svg": [
		89004,
		9004
	],
	"./bulletPointsDark.svg": [
		38044,
		8044
	],
	"./certifications.svg": [
		90996,
		996
	],
	"./checkScore.svg": [
		41295,
		1295
	],
	"./checkScoreBlack.svg": [
		21590,
		1590
	],
	"./company.svg": [
		2132,
		2132
	],
	"./contactNotFound.svg": [
		68748,
		8748
	],
	"./contactNotFoundDark.svg": [
		16028,
		6028
	],
	"./cross.svg": [
		84457,
		4457
	],
	"./custom.svg": [
		94040,
		4040
	],
	"./customSection.svg": [
		12835,
		2835
	],
	"./customSectionDark.svg": [
		11039,
		1039
	],
	"./dateIssue.svg": [
		5444,
		5444
	],
	"./dateIssueDark.svg": [
		52932,
		2932
	],
	"./description.svg": [
		59687,
		9687
	],
	"./diamond.svg": [
		27277,
		7277
	],
	"./duration.svg": [
		63881,
		3881
	],
	"./edit.svg": [
		87997,
		7997
	],
	"./editWhite.svg": [
		95522,
		5522
	],
	"./educationIcon.svg": [
		16568,
		6568
	],
	"./educationIconDark.svg": [
		84400,
		4400
	],
	"./educations.svg": [
		66492,
		6492
	],
	"./experienceIcon.svg": [
		59310,
		9310
	],
	"./experienceIconDark.svg": [
		55830,
		5830
	],
	"./feedback.svg": [
		73860,
		3860
	],
	"./getResumeScore.svg": [
		42696,
		2696
	],
	"./gmailLogo.svg": [
		93722,
		3722
	],
	"./grammerMistake.svg": [
		26032,
		6032
	],
	"./greenTick.svg": [
		54503,
		4503
	],
	"./home.svg": [
		57436,
		7436
	],
	"./import-pdf.svg": [
		23243,
		3243
	],
	"./import.svg": [
		72766,
		2766
	],
	"./importBlack.svg": [
		50405,
		405
	],
	"./issue.svg": [
		31312,
		1312
	],
	"./issueDark.svg": [
		16184,
		6184
	],
	"./languages.svg": [
		48240,
		8240
	],
	"./link.svg": [
		3969,
		3969
	],
	"./linkMissing.svg": [
		2609,
		2609
	],
	"./linkMissingDark.svg": [
		9253,
		9253
	],
	"./linkedinLogo.svg": [
		45302,
		5302
	],
	"./logout.svg": [
		80435,
		435
	],
	"./longSentence.svg": [
		50680,
		8299
	],
	"./menu.svg": [
		68612,
		8612
	],
	"./missingInfoExp.svg": [
		52576,
		2576
	],
	"./missingInfoExpDark.svg": [
		99272,
		9272
	],
	"./noIssue.svg": [
		79747,
		9747
	],
	"./noIssueDark.svg": [
		65119,
		5119
	],
	"./notFoundRed.svg": [
		59807,
		9807
	],
	"./overallIcon.svg": [
		3517,
		3517
	],
	"./overallIconDark.svg": [
		12777,
		2777
	],
	"./personalDetails.svg": [
		27243,
		7243
	],
	"./personalDetailsIcon.svg": [
		83672,
		3672
	],
	"./personalDetailsIconDark.svg": [
		39984,
		9984
	],
	"./premium.svg": [
		22458,
		2458
	],
	"./projects.svg": [
		5015,
		5015
	],
	"./projectsIcon.svg": [
		8548,
		8548
	],
	"./projectsIconDark.svg": [
		43940,
		3940
	],
	"./reset.svg": [
		24252,
		4252
	],
	"./resume-icon.svg": [
		62228,
		2228
	],
	"./resumeSettings.svg": [
		96227,
		6227
	],
	"./reverseOrder.svg": [
		77475,
		7475
	],
	"./reverseOrderDark.svg": [
		79807,
		2188
	],
	"./save-icon.svg": [
		87818,
		7818
	],
	"./save.svg": [
		75366,
		5366
	],
	"./saveDark.svg": [
		40670,
		670
	],
	"./score-check/Announcement.svg": [
		9932,
		9932
	],
	"./score-check/Arrowbg.svg": [
		43239,
		3239
	],
	"./score-check/RepeatedWords.svg": [
		21064,
		1064
	],
	"./score-check/SentenceMistakes.svg": [
		40073,
		73
	],
	"./score-check/ShortDesciption.svg": [
		87437,
		7437
	],
	"./score-check/SpeillingMistake.svg": [
		33082,
		3082
	],
	"./score-check/additionaldata.svg": [
		76574,
		6574
	],
	"./score-check/buzzWord.svg": [
		72954,
		2954
	],
	"./score-check/date.svg": [
		97989,
		7989
	],
	"./score-check/gap.svg": [
		77037,
		7037
	],
	"./score-check/grammarMistake.svg": [
		97100,
		7100
	],
	"./score-check/missing.svg": [
		42281,
		2281
	],
	"./score-check/overlap.svg": [
		50024,
		24
	],
	"./score-check/personalPronoun.svg": [
		80600,
		600
	],
	"./score-check/reverseOrder.svg": [
		84363,
		4363
	],
	"./score-check/spellingMistake.svg": [
		54863,
		4863
	],
	"./settings.svg": [
		68718,
		8718
	],
	"./share.svg": [
		25912,
		5912
	],
	"./signOut.svg": [
		91512,
		1512
	],
	"./skills.svg": [
		36695,
		6695
	],
	"./skillsIcon.svg": [
		6500,
		6500
	],
	"./spellingMistake.svg": [
		67191,
		7191
	],
	"./templates.svg": [
		97360,
		7360
	],
	"./uploadIcon.svg": [
		1773,
		1773
	],
	"./warningRed.svg": [
		40424,
		424
	],
	"./warningYellow.svg": [
		7389,
		7389
	],
	"./whatsappLogo.svg": [
		8866,
		8866
	],
	"./words.svg": [
		10210,
		210
	],
	"./workExperiences.svg": [
		58275,
		8275
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 81064;
module.exports = webpackAsyncContext;